import { adminCreateTag, AdminCreateTagData, HttpValidationError, Options } from "@/api";
import { TDataShape } from "@hey-api/client-fetch";
import { useCallback } from "react";
import { appState } from "@/app/appState";
import { InterfaceType } from "typescript";



// Define the expected structure of your API response
interface RequestResponse<EntryDataReturnType> {
    data?: EntryDataReturnType;
    error?: HttpValidationError | unknown;
    request?: Request;
    response?: Response;
}
// Define the endpoint function type
type EndpointFunction<TData extends TDataShape, EntryDataReturnType> = (
    options: Options<TData, false>
) => Promise<RequestResponse<EntryDataReturnType>>;

export function Request<TData extends TDataShape & { body?: any }, EntryDataReturnType, ArgumentsInterface = void>(
    endpoint: EndpointFunction<TData, EntryDataReturnType>,
    getOptions: (props: ArgumentsInterface) => Options<TData, false>,
    setLoading: (val: boolean) => void,
    onSuccess: (data: EntryDataReturnType, props: ArgumentsInterface) => void,
    onError: (error: HttpValidationError) => void,
    allowrequest: (props: ArgumentsInterface) => boolean,
    isStale?: () => boolean,
) {

    return async (props: ArgumentsInterface) => {
        if (allowrequest(props)) {
            try {
                setLoading(true);
                const response = await endpoint(getOptions(props));

                if (isStale?.()) return false;

                if (response.data) {
                    onSuccess(response.data, props);
                    return true
                } else if (response.error) {
                    onError(response.error)
                    if (response.response?.status == 401) {
                        appState.setModal(undefined)
                        appState.loadUser()
                    }
                }
            } catch (error) {
                // Handle unexpected errors

                console.log(error)

            } finally {
                setLoading(false);
            }
        }

        return false
    }
}
